module.exports = __webpack_public_path__ + "static/icons/person-end.11f0fbe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-end.gif
// module id = 2kBN
// module chunks = 1